"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    popoverScrollValuesVariants: ()=>popoverScrollValuesVariants,
    popoverAlignValues: ()=>popoverAlignValues,
    popoverScrollValues: ()=>popoverScrollValues,
    popoverSideValues: ()=>popoverSideValues,
    popoverSizesVariants: ()=>popoverSizesVariants,
    popoverVariants: ()=>popoverVariants,
    popoverSizes: ()=>popoverSizes
});
const tv_cjs_namespaceObject = require("../../variants/tv.cjs");
const popoverSideValues = [
    'bottom',
    'inline-end',
    'inline-start',
    'left',
    'right',
    'top'
];
const popoverAlignValues = [
    'start',
    'center',
    'end'
];
const popoverSizesVariants = {
    sm: {
        popupSlot: 'w-[256px]'
    },
    md: {
        popupSlot: 'w-[416px]'
    },
    lg: {
        popupSlot: 'w-[512px]'
    }
};
const popoverSizes = Object.keys(popoverSizesVariants);
const popoverScrollValuesVariants = {
    none: {
        bodySlot: ''
    },
    body: {
        popupSlot: 'h-full max-h-[calc(100dvh-40px)]',
        bodySlot: 'mb-6 px-6 pt-4',
        headingSlot: 'border-b-1 border-neutral-6/50',
        scrollAreaSlot: 'h-[calc(100dvh-113px)]',
        contentSlot: 'gap-0'
    }
};
const popoverScrollValues = Object.keys(popoverScrollValuesVariants);
const popoverVariants = (0, tv_cjs_namespaceObject.tv)({
    slots: {
        triggerSlot: 'inline-block',
        popupSlotAnimation: [
            'data-[starting-style]:opacity-0',
            'data-[ending-style]:opacity-0',
            'data-[ending-style]:translate-x-0 data-[ending-style]:translate-y-0',
            'data-[side=bottom]:data-[starting-style]:translate-y-[-10px]',
            'data-[side=top]:data-[starting-style]:translate-y-[10px]',
            'data-[side=left]:data-[starting-style]:translate-x-[-10px]',
            'data-[side=right]:data-[starting-style]:translate-x-[10px]',
            'data-[side=inline-end]:data-[starting-style]:translate-x-[10px]',
            'data-[side=inline-start]:data-[starting-style]:translate-x-[-10px]',
            'data-[side=bottom]:data-[open]:animate-scale-in-top',
            'data-[side=top]:data-[open]:animate-scale-in-bottom',
            'data-[side=left]:data-[open]:animate-scale-in-right',
            'data-[side=right]:data-[open]:animate-scale-in-left',
            'data-[side=inline-end]:data-[open]:animate-scale-in-left',
            'data-[side=inline-start]:data-[open]:animate-scale-in-right',
            'data-[side=bottom]:data-[closed]:animate-scale-out-top',
            'data-[side=top]:data-[closed]:animate-scale-out-bottom',
            'data-[side=left]:data-[closed]:animate-scale-out-right',
            'data-[side=right]:data-[closed]:animate-scale-out-left',
            'data-[side=inline-end]:data-[closed]:animate-scale-out-left',
            'data-[side=inline-start]:data-[closed]:animate-scale-out-right'
        ],
        popupSlot: 'shadow-overlay-md text-neutral-8 rounded-lg bg-[canvas]',
        arrowSlot: 'data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=right]:left-[-13px] data-[side=top]:bottom-[-8px] data-[side=left]:rotate-90 data-[side=right]:-rotate-90 data-[side=top]:rotate-180',
        headingTextSlot: 'text-heading4 text-neutral-13 font-semibold',
        closeButtonSlot: 'relative flex',
        headingSlot: 'flex w-full flex-row items-center gap-3 px-5 pb-3 pr-3 pt-3',
        headingCustomSlot: 'w-full',
        headingLeftSlot: 'flex flex-grow flex-row text-xl',
        headingRightSlot: '',
        headingCloseButtonSlot: '',
        positionerSlot: '',
        headingIconSlot: 'text-neutral-13 mr-2',
        backdropSlot: '',
        bodySlot: '',
        bodyTextSlot: 'text-body2 inline-block w-full px-5 pb-5',
        footerSlot: '',
        popupScrollWrapperSlot: '',
        scrollAreaSlot: '',
        contentSlot: 'relative flex flex-col'
    },
    variants: {
        size: popoverSizesVariants,
        scroll: popoverScrollValuesVariants,
        customHeader: {
            true: {
                contentSlot: 'pt-0'
            }
        },
        customFooter: {
            true: {
                contentSlot: 'pb-0'
            }
        },
        customBody: {
            true: {
                contentSlot: 'gap-0',
                bodySlot: 'px-0 pb-0 pt-0'
            }
        },
        noHeading: {
            true: {
                headingCloseButtonSlot: 'z-1 absolute right-[-12px] top-[-12px]',
                bodyTextSlot: 'text-body2 inline-block w-full px-5 pb-5 pt-5'
            }
        },
        stickyFooter: {
            true: {
                footerSlot: 'sticky bottom-0 left-0 right-0'
            }
        }
    },
    compoundVariants: [
        {
            customHeader: true,
            class: {
                headingSlot: 'flex w-full flex-row items-center justify-between',
                headingCustomSlot: 'w-full'
            }
        },
        {
            customHeader: true,
            customFooter: true,
            scroll: 'body',
            class: {
                bodySlot: 'mb-0',
                scrollAreaSlot: 'h-[calc(100dvh-90px)]'
            }
        },
        {
            customBody: false,
            scroll: 'body',
            class: {
                bodySlot: 'px-0'
            }
        },
        {
            customHeader: true,
            customBody: false,
            class: {
                bodySlot: 'pt-3'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        scroll: 'none',
        stickyFooter: false
    }
});
exports.popoverAlignValues = __webpack_exports__.popoverAlignValues;
exports.popoverScrollValues = __webpack_exports__.popoverScrollValues;
exports.popoverScrollValuesVariants = __webpack_exports__.popoverScrollValuesVariants;
exports.popoverSideValues = __webpack_exports__.popoverSideValues;
exports.popoverSizes = __webpack_exports__.popoverSizes;
exports.popoverSizesVariants = __webpack_exports__.popoverSizesVariants;
exports.popoverVariants = __webpack_exports__.popoverVariants;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "popoverAlignValues",
    "popoverScrollValues",
    "popoverScrollValuesVariants",
    "popoverSideValues",
    "popoverSizes",
    "popoverSizesVariants",
    "popoverVariants"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
